import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'

import DiiaMessageBox from './components/DiiaMessageBox.vue';

import httpClientSecure from './plugins/httpClientSecure';

import store from './store';

Vue.component('DiiaMessageBox', DiiaMessageBox);

Vue.use(httpClientSecure);


if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$config = require('./config/production').default;
} else if (process.env.NODE_ENV === 'staging') {
  Vue.prototype.$config = require('./config/staging').default;
} else {
  // FOR VUE SERVE
  Vue.prototype.$config = require('./config').default;
}

Vue.prototype.$clib = require('./js/common_lib').default;

// ?!
Vue.prototype.$authData = "";

Vue.prototype.$crossServer = require('cross-domain-storage/guest');

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  data: {
    authData: Vue.prototype.$authData,
  },
  watch: {
    authData: {
      handler(newValue) {
        this.$store.dispatch('updateAuthData', newValue);
      },
      deep: true,
    },
  },
  render: h => h(App)
}).$mount('#app')